import { useQueryClient } from "react-query";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useRequestStakeDebitCard } from "../../../CustomHooks/Mutations";

import { useModalContext } from "../../../Contexts/ModalContext";

import { dispatchAPIErrorToast } from "../../../Utils/helpers";
import { APIQueryKeys, modalVariants } from "../../../Utils/constants";

import { StakeCardFrontRotated } from "../../../Assets/Images";

export default function renderInstantReleaseRequestCard(modalContext) {
  const { updateModalComponent, setModalVariant, setModalPromoComponent, setModalTitle, setModalClassName, setModalAriaLabel } =
    modalContext;

  updateModalComponent(InstantReleaseRequestCard);
  setModalPromoComponent?.(null);
  setModalTitle("");
  setModalAriaLabel?.("Request your Stake card");
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("position-close-button-over-content light-close-button");
}

const InstantReleaseRequestCard = () => {
  const queryClient = useQueryClient();
  const { onModalClose } = useModalContext();

  const { isLoading: isRequestingCard, mutate: requestCard } = useRequestStakeDebitCard({
    onSuccess: async () => {
      await queryClient.refetchQueries(APIQueryKeys.stakeDebit);
      onModalClose();
    },
    onError: (e) => dispatchAPIErrorToast({ message: e?.response?.data?.error }),
  });

  return (
    <>
      <div className="modal-image stake-debit-single-card">
        <img src={StakeCardFrontRotated} alt="" />
      </div>
      <div className="modal-dialog-content">
        <span className="modal-status-title mt-6 mb-5">Request your Stake card</span>
        <span className="text-lg-regular color--american-silver mb-2">
          Your account is funded. Request your card to start spending.
        </span>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={() => requestCard("VIRTUAL")} disabled={isRequestingCard}>
          Request card {isRequestingCard && <CircularProgress />}
        </PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={onModalClose} disabled={isRequestingCard}>
          Skip for now
        </PrimaryButton>
      </div>
    </>
  );
};
